export const BINGO_BOARD_SESSION_KEY = "HALLMARK_BINGO_BOARD";
